import type { Query } from './../type/query.d';
import { LANGUAGE_CODES } from './constants';
const { es, en } = LANGUAGE_CODES;

export const getLangPath = (lang: string): string => (lang === es ? es : en);

/**
 * get lang url base on lang code, English lang url is empty, Spanish lang url is /es
 * for example: en -> /blog/a-new-post
 *              es -> /es/blog/a-new-post
 *
 * @param {string} lang lang code, en or es
 *
 * @return {string} lang url
 */
export const getLangUrl = (lang: string): string => (lang === es ? '/es' : '');

export const getLangFromLanguageCodes = (lang: string, defaultLang: string = en): string => {
  return LANGUAGE_CODES[lang] || defaultLang;
};

export const hasLangInRoutes = (routes: string[]): boolean => {
  return !!LANGUAGE_CODES[routes[0]];
};

export const getLangParamFromRoute = (sapperRestRoute: string[]): string => {
  if (!sapperRestRoute.length) {
    return '';
  }
  const parsedRouteList = sapperRestRoute[0];
  const lang = getLangFromLanguageCodes(parsedRouteList);
  return lang === en ? '' : lang;
};

export const getDynamicCacheKey = (sapperRestRoute: string[]): string => {
  if (!sapperRestRoute.length) {
    return en;
  }

  if (hasLangInRoutes(sapperRestRoute)) {
    const [lang, ...dynamicRoute] = sapperRestRoute;
    if (dynamicRoute.length === 0) return lang;
    return `${getLangFromLanguageCodes(lang)}/${dynamicRoute.join('/')}`;
  }

  return `${en}/${sapperRestRoute.join('/')}`;
};

export const getLangCacheKey = (sapperRestRoute: string[]): string => {
  if (!sapperRestRoute.length || !hasLangInRoutes(sapperRestRoute)) {
    return en;
  }

  const [lang] = sapperRestRoute;
  return getLangFromLanguageCodes(lang);
};

export const buildURL = (url: string, query: Query): string => {
  let newURL = url;

  // clean trailing slash to prevent 301s
  if (newURL[newURL.length - 1] === '/') {
    newURL = newURL.slice(0, newURL.length - 1);
  }

  if (!query || Object.keys(query).length === 0) {
    return newURL;
  }

  for (const param in query) {
    if (Object.prototype.hasOwnProperty.call(query, param)) {
      if (newURL.indexOf('?') === -1) {
        newURL = `${newURL}?${param}=${query[param]}`;
      } else {
        newURL = `${newURL}&${param}=${query[param]}`;
      }
    }
  }
  return newURL;
};
